import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { Detail, DetailHeader, SelectField, InputField, SidePanelTable, ToggleField, Modal } from 'cx-ui-components';
import DetailWrapper from '../../../components/DetailWrapper';
import { Field } from 'redux-form/immutable';
import { detailHeaderText } from '../../../utils';
import { entitiesMetaData } from '../../../redux/modules/entities/metaData';

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
`;

const WrapperRow = styled.div`
  display: flex;
  flex-direction: row;
`;

const WrappedDetailHeader = styled(DetailHeader)`
  margin-left: 35px;
`;

const CheckboxLabel = styled.div`
  margin: 0px 10px 20px 10px;
  display: flex;
  font-size: 13px;
  line-height: 1.5em;
`;

const CheckboxText = styled.p`
  margin: 0px;
  font-size: 13px;
  line-height: 1.5em;
`;
const Checkbox = styled.input`
  margin-right: 10px;
  margin-top: 4px;
  transform: scale(1.2);
  pointer-events:none;
`;
export default function AmrPanel({
  initialValues,
  displayValues,
  sidePanelData,
  statusRequestDetails,
  artifactFilesDeleted,
  artifactFailedLocked,
  artifactsProcessedCount,
  interactionsProcessedCount,
  interactionsRemainingCount,
  errorCount,
  displayData,
  artifactSubtypes,
  key,
  userHasUpdatePermission,
  userHasViewPermission,
  alpFetching,
  versionsItems,
  setSelectedSubEntityId,
  itemApiPending,
  submittedValues
}) {

  return (
    <form key={key}>
      <Wrapper>
        <DetailWrapper open data-automation="amrSideRequestStatusSVG">
          <WrappedDetailHeader text="Request Status" />
          <WrapperRow>
            <Wrapper>
              <Detail
                label="Status"
                value={statusRequestDetails}
              />
              <Detail
                label="Errors"
                value={errorCount}
              />
              <Detail
                label="Interactions Processed"
                value={interactionsProcessedCount}
              />
              <Detail
                label="Interactions Remaining"
                value={interactionsRemainingCount}
              />
            </Wrapper>
            <Wrapper></Wrapper>
            <Wrapper>
              <Detail
                label="Artifact Processed"
                value={artifactsProcessedCount}
              />
              <Detail
                label="Artifacts Failed - Deleted"
                value={artifactFilesDeleted}
              />
              <Detail
                label="Artifacts Failed - Locked"
                value={artifactFailedLocked}
              />
            </Wrapper>
          </WrapperRow>
          <SidePanelTable
            tableType={'sidePanel'}
            items={sidePanelData}
            fields={entitiesMetaData.amr.membersTableFields['view']}
            defaultSorted={[{ id: 'interactionId', desc: true }]}
          />
        </DetailWrapper>

        <DetailWrapper open data-automation="amrSideRequestDetailsSVG">
          <WrappedDetailHeader text="Request Details" />
          <Detail
                label="Description"
                value={displayValues.description}
              />
          <Detail
            label="Request Type"
            value={displayValues.requestType}
          />
          <ToggleField
            id="frm-delete-default"
            name="removeLock"
            label="Remove Locks to Process Request"
            disabled={true}
            data-automation="isDefaultToggle"
          />
          <Field
            name="tncAccepted"
            type="checkbox"
            labelChildren={"I understand it may take up to 12-hours to move artifacts from long-term storage to active storage and there is an Archive Storage Retrieval cost per GB in a calendar month."}
            normalize={(value) => value === true}
            component={({ labelChildren, input }) => (
              <CheckboxLabel>
                <Checkbox {...input} type="checkbox" required={true} />
                <CheckboxText>{labelChildren}</CheckboxText>
              </CheckboxLabel>
            )}
            required={true}
          />
          <Field
            name="tncAccepted"
            type="checkbox"
            labelChildren={"I acknowledge artifacts kept in Active Storage are subject to Fair Use Active Data Storage limits and may result in Active Storage Usage Overage cost per GB in a calendar month."}
            normalize={(value) => value === true}
            component={({ labelChildren, input }) => (
              <CheckboxLabel>
                <Checkbox {...input} type="checkbox" required={true} />
                <CheckboxText>{labelChildren}</CheckboxText>
              </CheckboxLabel>
            )}
            required={true}
          />
        </DetailWrapper>

        <DetailWrapper open data-automation="amrSideArtifactTypeSVG">
          <WrappedDetailHeader text="Artifact Type" />
          <Detail
            label="Artifact Type"
            value={displayValues.artifactTypeStr}
          />
        </DetailWrapper>
      </Wrapper>
    </form>
  );
}

AmrPanel.propTypes = {
  userHasUpdatePermission: PropTypes.bool,
  userHasViewPermission: PropTypes.bool,
  artifactSubtypes: PropTypes.array,
  alpFetching: PropTypes.bool,
  versionsItems: PropTypes.array,
  itemApiPending: PropTypes.string,
  setSelectedSubEntityId: PropTypes.func,
};
